export const LT_SAVINGS_DATA_RECEIVED = 'LT_SAVINGS_DATA_RECEIVED'
export const LT_SAVINGS_DATA_SAVED = 'LT_SAVINGS_DATA_SAVED'
export const LT_SAVINGS_DATA_DELETED = 'LT_SAVINGS_DATA_DELETED'
export const LT_SAVINGS_UNLOADED = 'LT_SAVINGS_UNLOADED'
